<template>
  <div>
    <div class="title">物流信息</div>
    <div class="item-wrap">
      <div class="item">
        <label>订单编号：</label>
        <span>{{data.order_number}}</span>
      </div>
      <div class="item">
        <label>配送：</label>
        <span>快递</span>
      </div>
      <div class="item">
        <label>物流编号：</label>
        <span>{{data.logistics_no}}</span>
      </div>
      <div class="item">
        <label>收货人：</label>
        <span>{{data.consignee}}</span>
      </div>
    </div>
    <div class="item-wrap">
      <div class="item">
        <label>发货单号：</label>
        <span>{{data.logistics_number}}</span>
      </div>
      <div class="item">
        <label>物流公司：</label>
        <span>{{data.logistics_name}}</span>
      </div>
      <div class="item">
        <label>物流费用：</label>
        <span>{{data.logistics_fee/100}}</span>
      </div>
      <div class="item">
        <label>收货人手机号：</label>
        <span>{{data.mobile}}</span>
      </div>
    </div>
    <div class="item-wrap">
      <div class="item">
        <label>操作人：</label>
        <span>{{data.creator_name}}</span>
      </div>
      <div class="item" style="width:75%;">
        <label>收货地址：</label>
        <span>{{data.province_name+data.city_name+data.district_name+data.address}}</span>
      </div>
    </div>
    <div class="title">发货信息</div>
    <table>
      <thead>
        <tr>
          <th>发货类型</th>
          <th>发货商品</th>
          <th>发货量</th>
          <th>发货说明</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{data.product_type==12?'图书':''}}</td>
          <td>{{data.product_name}}</td>
          <td>{{data.product_number}}</td>
          <td>{{data.remark}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "OrderShipDetail",
  data() {
    return {
      id: this.$route.query.id,
      data: {}
    };
  },
  async created() {
    this.data = await this.$http.get("/api/ship/show/" + this.id);
  }
};
</script>
<style lang="scss" scoped>
.item-wrap {
  margin-bottom: 20px;
  display: flex;
  .item {
    width: 25%;
  }
}
table {
  width: 100%;
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #ccc;
    text-align: center;
    padding: 10px 0;
  }
}
</style>